/**
 * Fundbox Fuse — in-page iframe mount target.
 *
 * Renders #fundbox-app-wrapper with data-fundbox-domain and data-fundbox-id. The per-user
 * data-fundbox-auth-token is set imperatively on the mount node by useFundboxFuseEmbed before
 * launch (FSS OAuth code). fuse.js injects the Fundbox iframe into the mount div.
 */

import type { FundboxFuseConfig } from '@/enterprise/features/fundbox/fuse/fundboxFuseConfig';

interface FundboxFuseEmbedProps {
  fuseConfig: FundboxFuseConfig;
  mountRef: (node: HTMLDivElement | null) => void;
}

const FundboxFuseEmbed = ({ fuseConfig, mountRef }: FundboxFuseEmbedProps): JSX.Element => (
  <section aria-label="Fundbox application" className="h-full min-h-0 overflow-hidden rounded-2xl bg-white shadow-md">
    <div
      ref={mountRef}
      id="fundbox-app-wrapper"
      data-fundbox-domain={fuseConfig.domain}
      data-fundbox-id={fuseConfig.partnerId}
      className="h-full w-full"
    />
  </section>
);

export default FundboxFuseEmbed;
